import cn from "classnames";
import "./index.css";
import BgTransformer from "../../../layout/BgTransformer";
import PixelationLayer from "../../../layout/PixelationLayer";
import Textarea from "../../../layout/Textarea/Textarea";
import {useSetting} from "../../../contexts/setting";
import {useEdits} from "../../../contexts/edits";
import {useBgUrl} from "hooks/useBgUrl";
import {type DemoVideoTexts, DemoVideoIcon, DemoVideoScreenshot} from "./parts";

/**
 * Intro + Demo (Figma "release/intro-demo/light" 12710:1430 and "…/dark"
 * 12710:1439): the product icon and the headline on the left, the screenshot
 * on the right, over the product artwork. The screenshot runs off the right
 * and bottom edges.
 */
const DemoVideoIntroDemo = ({id, zoom}: {id: string; zoom: number}) => {
  const {product} = useSetting();
  const {url: bgUrl} = useBgUrl();
  const {titles}: DemoVideoTexts<"titles"> = useEdits();
  const title = titles[id] || titles.main;

  return (
    <div
      id={id}
      className={cn("template", product.value, "demo-video", "demo-video-intro-demo")}
      style={{"--zoom-level": zoom} as React.CSSProperties}
    >
      <div>
        <BgTransformer src={bgUrl} id={id} />
        <PixelationLayer />
        <div className="content">
          <DemoVideoIcon />
          <h1 className="title">
            <Textarea id={id} text={title} />
          </h1>
        </div>
        <DemoVideoScreenshot id={id} />
      </div>
    </div>
  );
};

export default DemoVideoIntroDemo;
